// extracted by mini-css-extract-plugin
module.exports = {"dot":"livestream-event-LiveIndicator__dot--3n4pD","blinking":"livestream-event-LiveIndicator__blinking--SGgx9"};